import { useForm, Controller } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { IGetAgendamentosProps } from "../../../types/agendamento";
import { StatusAgendamentoEnum } from "../../../enums/statusAgendamento";
import { TipoAtendimentoEnum } from "../../../enums/tipoAtendimento";
import { useMunicipioLista } from "../../../hooks/queries/municipio/useMunicipioLista/useMunicipioLista";
import { maskCnpj, maskCpf } from "../../../utils/masks";

const schema = z.object({
  dataInicial: z.string().optional(),
  dataFinal: z.string().optional(),
  cidade: z.string().optional(),
  tipoAtendimento: z.string().optional(),
  renavam: z.string().optional(),
  placa: z.string().optional(),
  chassi: z.string().optional(),
  cpfCnpj: z.string().optional(),
  nome: z.string().optional(),
  statusAgendamento: z.string().optional(),
});

const DEFAULT_VALUES: IGetAgendamentosProps = {
  dataInicial: "",
  dataFinal: "",
  cidade: "",
  tipoAtendimento: undefined,
  renavam: "",
  placa: "",
  chassi: "",
  cpfCnpj: "",
  nome: "",
  statusAgendamento: undefined,
};

export const useSchedulesFilterFormV2 = () => {
  const { data: municipios } = useMunicipioLista();

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<IGetAgendamentosProps>({
    defaultValues: DEFAULT_VALUES,
    resolver: zodResolver(schema),
  });

  const cidadeOptions = (municipios || []).map((item) => ({
    value: item.nome.toUpperCase(),
    label: item.nome,
  }));

  const tipoOptions = Object.values(TipoAtendimentoEnum).map((item) => ({
    value: item,
    label: item,
  }));

  const statusOptions = Object.values(StatusAgendamentoEnum).map((item) => ({
    value: item,
    label: item.split("_").join(" "),
  }));

  function handleCpf(value: string) {
    const masked = value?.length > 14 ? maskCnpj(value) : maskCpf(value);
    setValue("cpfCnpj", masked || "");
  }

  function handleClear() {
    reset(DEFAULT_VALUES);
  }

  return {
    Controller,
    control,
    handleSubmit,
    errors,
    cidadeOptions,
    tipoOptions,
    statusOptions,
    handleCpf,
    handleClear,
  };
};
